import React, { FC } from "react";
import styles from "./white.module.scss";

const White: FC = ({ children }) => (
	<div className={styles.white}>{children}</div>
);

export default White;
